import * as React from "react";
const SvgClose24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 14,
        fill: "black",
        viewBox: "0 0 15 14"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m7.5 8.414 5.293 5.293 1.414-1.414L8.914 7l5.293-5.293L12.793.293 7.5 5.586 2.207.293.793 1.707 6.086 7 .793 12.293l1.414 1.414L7.5 8.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgClose24Px;
